module.exports = __webpack_public_path__ + "static/logo-roof-only-3f6b40898242ff57dbd1c3e01f87f653.png";